import React from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import { Col, Row } from 'react-bootstrap';
import NoDataAvailable from './NoDataAvailable';
import ChartTitle from '../../../../elements/ChartTitle';
import { useQuery } from '@tanstack/react-query';
import { fetchTestCasePyramidMetrics } from '../../../../../modules/dashboard';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const TestCasePyramidMetrics = ({ projectId }) => {
  const { data = [] } = useQuery({
    queryKey: ['testCasePyramidMetrics', projectId],
    queryFn: async () => {
      const response = await fetchTestCasePyramidMetrics(projectId);
      return response?.data || [];
    },
    enabled: !!projectId,
    refetchOnWindowFocus: false,
  });

  const preparePyramidData = (data, key) => {
    const filteredData = data.filter(item => parseInt(item[key], 10) > 0);
    if (filteredData.length === 0) return [];
    const formattedData = filteredData.map((item) => ({
      label: item.technology_layer,
      y: parseInt(item[key], 10) || 0,
    }));

    let total = formattedData.reduce((acc, item) => acc + item.y, 0);
    return formattedData.map((item) => ({
      ...item,
      percentage: total > 0 ? Math.round((item.y / total) * 100) : 0,
    }));
  };

  const totalTestCases = preparePyramidData(data, 'test_case_count');
  const automatedTestCases = preparePyramidData(data, 'automated_test_case_count');

  const options = (dataPoints) => ({
    animationEnabled: true,
    height: 320,
    legend: {
      horizontalAlign: 'center',
      fontSize: 14,
      fontWeight: 400,
    },
    data: [
      {
        type: 'pyramid',
        showInLegend: true,
        legendText: '{label}',
        indexLabel: '{label} - {y}',
        toolTipContent: '{label}: {y} ({percentage}%)',
        dataPoints: dataPoints,
        indexLabelFontFamily: "'Roboto', 'Helvetica', sans-serif",
        indexLabelFontSize: 12,
      },
    ],
  });

  return (
    <Row>
      <Col md={6}>
        <div className="chart-div">
          <ChartTitle title="Test Cases By Technology Layer" />
          {totalTestCases.length === 0 ? (
            <NoDataAvailable type="other" />
          ) : (
            <CanvasJSChart options={options(totalTestCases)} />
          )}
        </div>
      </Col>
      <Col md={6}>
        <div className="chart-div">
          <ChartTitle title="Automated Test Cases By Technology Layer" />
          {automatedTestCases?.length === 0 ? (
            <NoDataAvailable type="other" />
          ) : (
            <CanvasJSChart options={options(automatedTestCases)} />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default TestCasePyramidMetrics;
